/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/support'
export default icon
